// imports
import * as bootstrap from 'bootstrap'
import GLightbox from 'glightbox'
import Headroom from 'headroom.js'
import Splide from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'
import Swal from 'sweetalert2'

// bootstrap
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl))

// headroom
function initHeadroom() {
  const headroomMenu = document.querySelector('.menu-container')
  var headroomOptions = {
    offset: {
      up: 72,
      down: 0,
    },
  }
  const headroom = new Headroom(headroomMenu, headroomOptions)
  headroom.init()
}

// splide
function initMainSplide() {
  const splideDestaques = document.getElementById('splide-destaques')
  if (!splideDestaques) {
    console.log('The destaques splide is not present.')
    return
  }

  var splide = new Splide('.splide-destaques', {
    autoplay: true,
    arrows: { prev: HTMLButtonElement, next: HTMLButtonElement },
    breakpoints: {
      768: {
        padding: '6rem',
      },
      992: {
        padding: '9rem',
      },
      1200: {
        padding: '12rem',
      },
    },
    gap: '3rem',
    interval: 3000,
    mediaQuery: 'min',
    padding: 0,
    pagination: false,
    perPage: 1,
    speed: 1500,
    type: 'loop',
  })
  splide.mount()
}

function initFooterSplide() {
  const splideFooter = document.getElementById('splide-footer')
  if (!splideFooter) {
    console.log('The footer splide is not present.')
    return
  }

  var splide = new Splide('.splide-footer', {
    arrows: false,
    autoScroll: {
      speed: 0.4,
    },
    autoWidth: true,
    breakpoints: {
      1200: {
        gap: '6rem',
      },
    },
    drag: 'free',
    focus: 'center',
    gap: '3rem',
    mediaQuery: 'min',
    pagination: false,
    type: 'loop',
  })
  splide.mount({ AutoScroll })
}

// form
function initFormSubmission() {
  const engage = document.getElementById('engage')
  if (!engage) {
    console.log('The engage form is not present.')
    return
  }

  engage.addEventListener('submit', async (e) => {
    e.preventDefault()

    const json = JSON.stringify(Object.fromEntries(new FormData(engage)))

    Swal.fire({
      icon: 'info',
      title: 'Enviando formulário',
      html: 'Por favor, aguarde...',
      didOpen: () => Swal.showLoading(),
    })

    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: json,
      })

      const data = await res.json()

      Swal.fire({
        icon: res.ok ? 'success' : 'error',
        title: res.ok ? 'Sua mensagem foi enviada' : 'Erro inesperado',
        text: res.ok
          ? 'Agradecemos demais pelo seu interesse. O Marco da Moda está em período de recesso e todas as mensagens serão respondidas a partir de 12/Janeiro. Até logo e Feliz Ano Novo! 🎉'
          : data.message,
        confirmButtonText: 'OK',
        confirmButtonColor: '#1098f7',
      })
    } catch (err) {
      console.error(err)
      Swal.fire({
        icon: 'error',
        title: 'Erro inesperado',
        text: 'Alguma coisa deu errado no envio do formulário. Por favor, tente novamente em alguns minutos.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#1098f7',
      })
    }
  })
}

// input mask
function initPhoneMask() {
  const formTelefone = document.getElementById('form-telefone')
  if (!formTelefone) {
    console.log('The input to mask is not present.')
    return
  }

  formTelefone.addEventListener('input', (e) => {
    let value = e.target.value.replace(/\D/g, '')
    if (value.length > 11) value = value.slice(0, 11)

    let formatted = ''
    if (value.length > 0) {
      formatted += '(' + value.substring(0, 2)
    }
    if (value.length >= 3) {
      formatted += ') '
      formatted += value.length >= 11 ? value.substring(2, 7) : value.substring(2, 6)
    }
    if (value.length >= 7) {
      formatted += '-' + (value.length >= 11 ? value.substring(7, 11) : value.substring(6, 10))
    }

    e.target.value = formatted
  })
}

function initLightbox() {
  const customSlideHTML = `
    <div class="gslide">
      <div class="gslide-inner-content">
        <div class="ginner-container">
          <div class="gslide-media"></div>
          <div class="gslide-description">
            <div class="[ bg-gradient-primary ] gdesc-inner">
              <h6 class="[ fw-bold text-white mb-2 ] gslide-title"></h6>
              <div class="[ text-light ] gslide-desc"></div>
            </div>
          </div>
        </div>
      </div>
    </div>`

  GLightbox({
    selector: '.glightbox',
    slideHTML: customSlideHTML,
  })
}

// global init
document.addEventListener('DOMContentLoaded', () => {
  initHeadroom()
  initMainSplide()
  initFooterSplide()
  initFormSubmission()
  // initPhoneMask()
  // initLightbox()
})
